import React from "react";
import { InView } from "react-intersection-observer";

const DownloadApp = () => {
  return (
    <div className="bg-gradient-to-br from-purple-900/20 via-gray-950 to-pink-900/20 py-20">
      <div className="container mx-auto px-6 flex flex-col items-center text-center">
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`max-w-2xl transform transition-all duration-700 ${
                inView ? "animate__animated animate__fadeInUp" : "opacity-0 translate-y-10"
              }`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-6">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Download Our App
                </span>
              </h2>
              <p className="text-lg text-gray-300 mb-4 font-semibold">
                Get instant access to powerful design tools on your mobile!
              </p>
              <p className="text-gray-400 mb-8 leading-relaxed">
                Download the <strong className="text-purple-400">Edit Ezy</strong> app to create beautiful
                posters, business cards, and marketing materials on the go. Available on both Android and iOS.
              </p>

              <a
                href="https://apkpure.com/group/in.poster.editezy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-10 py-5 text-white font-bold rounded-full shadow-2xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 hover:shadow-purple-500/50 text-lg"
              >
                Download Now - Start Creating Free
              </a>
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default DownloadApp;